<template>
  <!-- 可滚动内容区域 -->
  <div class="scroll-content" ref="scrollContent" @scroll="handleScroll">
    <date-range-picker v-model="dateRange" @change="handleDateChange" />
    <div class="core">
      <p>核心指标</p>
      <div class="cor_fat">
        <div class="co_ft_item">
          <span>消耗金额</span><span>{{ aggregate.consumeAmount }}</span>
        </div>
        <div class="co_ft_item">
          <span>激活数</span><span>{{ aggregate.conversion }}</span>
        </div>
        <div class="co_ft_item">
          <span>转化成本</span><span>{{ aggregate.conversionCost }}</span>
        </div>
        <div class="co_ft_item">
          <span>CTR</span><span>{{ aggregate.ctr }}</span>
        </div>
        <div class="co_ft_item">
          <span>CVR</span><span>{{ aggregate.cvr }}</span>
        </div>
      </div>
    </div>

    <div class="grid">
      <div class="grid_tab">
        <span
          v-for="item in tabGroup"
          :key="item.value"
          :class="parameter.groupType == item.value ? 'active' : ''"
          @click="SelectTab(item)"
        >
          {{ item.name }}
          <u></u>
        </span>
      </div>
      <div class="ac">
        <picker-selector
          style="width: 116px"
          v-model="parameter.productId"
          :options="allProducts"
          placeholder="全部产品"
          @change="handleProductSelect"
        />

        <picker-selector
          style="width: 116px"
          v-if="parameter.groupType == '0'"
          v-model="parameter.advertiserId"
          :options="allAdvert"
          search-mode="account"
          placeholder="全部账户"
          @change="handleAdvertSelect"
        />
      </div>

      <div class="tabulate">
        <div class="area" v-for="(item, index) in listData" :key="index">
          <div class="crown" v-if="parameter.groupType == '0'">
            <span>{{ item.advertiserId }}</span
            ><span class="tick">{{
              item.productName ? item.productName : ""
            }}</span>
          </div>
          <div class="crown" v-else>
            {{ item.productName ? item.productName : "" }}
          </div>
          <div class="cor_fat area_fat">
            <div class="co_ft_item">
              <span>消耗金额</span><span>{{ item.consumeAmount }}</span>
            </div>
            <div class="co_ft_item">
              <span>激活数</span><span>{{ item.conversion }}</span>
            </div>
            <div class="co_ft_item">
              <span>转化成本</span><span>{{ item.conversionCost }}</span>
            </div>
            <div class="co_ft_item">
              <span>CTR</span><span>{{ item.ctr }}</span>
            </div>
            <div class="co_ft_item">
              <span>CVR</span><span>{{ item.cvr }}</span>
            </div>
          </div>
          <div class="trend" @click="toggleChart(item, index)">
            今日趋势
            <img
              src="../../assets/images/arrow.png"
              alt=""
              :style="{
                transform: item.showChart ? 'rotate(180deg)' : 'rotate(0deg)',
              }"
            />
          </div>

          <div class="figure" v-if="item.showChart">
            <div v-if="item.isChartLoading" class="loading-indicator">
              <van-loading size="24px" type="spinner" vertical
                >加载中...</van-loading
              >
            </div>
            <template v-else>
              <div class="lfSide">
                <span class="pres" @click="handelSens(item, index)">
                  {{ item.sensitize || "激活" }}
                  <img src="../../assets/images/down.png" alt="" />
                </span>
              </div>
              <div
                class="rtSide"
                :style="{ color: calculateComparison(item).color }"
              >
                <img
                  v-if="calculateComparison(item).trendIcon"
                  :src="calculateComparison(item).trendIcon"
                  alt="trend"
                  class="trend-icon"
                />
                {{ calculateComparison(item).formattedValue }}
              </div>
              <div :id="'chart-' + index" class="chart"></div>
            </template>
          </div>
        </div>

        <van-loading v-if="loading" size="24px" type="spinner" vertical>
          加载中...
        </van-loading>
        <!-- <div v-if="finished" class="no-more">没有更多数据了</div> -->
      </div>
    </div>

    <van-action-sheet v-model="showUs" :actions="actions" @select="onSelect" />
  </div>
</template>

<script>
import DateRangePicker from "@/components/DateRangePicker.vue";
import PickerSelector from "@/components/PickerSelector.vue";
import * as echarts from "echarts";
import {
  ProductData,
  AccountData,
  OverviewData,
  AnalysisData,
  TrendChart,
} from "@/api/modules/home";

export default {
  name: "HomePage",
  components: {
    DateRangePicker,
    PickerSelector,
  },
  data() {
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    const today = new Date();
    const todayStr = formatDate(today);
    return {
      tabGroup: [
        { name: "产品", value: "1" },
        { name: "账户", value: "0" },
      ],
      dateRange: {
        startDate: todayStr,
        endDate: todayStr,
      },
      parameter: {
        pageNo: 1,
        pageSize: 20,
        groupType: 1,
        startDate: todayStr,
        endDate: todayStr,
        productId: "",
        advertiserId: "",
      },
      allProducts: [],
      allAdvert: [],
      aggregate: {},
      listData: [],
      loading: false, // 加载状态
      finished: false, // 是否已加载完所有数据
      total: 0, // 总数据量
      showUs: false,
      actions: [
        { name: "激活", value: "1" },
        { name: "消耗", value: "0" },
      ],
      currentIndex: null,
      currentItem: null,

      chart: null,
      scrollLock: false, // 防止重复触发滚动加载
    };
  },
  async created() {
    try {
      await Promise.all([
        this.loadProducts(), // 加载产品数据
        this.getGeneral(), // 获取概览数据
        this.tabularData(), // 加载表格数据
      ]);
    } catch (error) {
      console.log();
    }
  },

  mounted() {},
  beforeDestroy() {},
  methods: {
    // 计算今日与昨日的对比值
    calculateComparison(item) {
      if (!item.chartData)
        return {
          value: 0,
          formattedValue: "0%",
          color: "#000000",
        };
      const todayTotal = this.calculateArrayTotal(
        item.chartData.startList || []
      );
      const yesterdayTotal = this.calculateArrayTotal(
        item.chartData.endList || []
      );
      if (yesterdayTotal === 0 || isNaN(todayTotal) || isNaN(yesterdayTotal)) {
        return {
          value: 0,
          formattedValue: "0%",
          color: "#000000",
        };
      }
      const percentage = ((todayTotal - yesterdayTotal) / yesterdayTotal) * 100;
      const value = Number(percentage.toFixed(2));

      // 确定颜色和图标
      let color = "#000000"; // 默认黑色
      let icon = "";

      if (value > 0) {
        color = "#52C41A"; // 绿色
        icon = "up.png";
      } else if (value < 0) {
        color = "#F5222D"; // 红色
        icon = "below.png";
      }

      return {
        value,
        formattedValue: `${Math.abs(value)}%`, // 绝对值，不显示负号
        color,
        trendIcon: require(`@/assets/images/${icon}`),
      };
    },
    // 计算数组总和
    calculateArrayTotal(arr) {
      return arr.reduce((sum, current) => sum + current, 0);
    },
    handelSens(item, index) {
      this.showUs = true;
      this.currentIndex = index;
      this.currentItem = item;
    },
    // 切换图表显示状态
    toggleChart(item, index) {
      console.log(item, index);
      const wasClosed = !item.showChart;
      this.$set(item, "showChart", wasClosed);
      if (item.showChart) {
        if (!item.chartData) {
          // 无缓存时加载
          item.isChartLoading = true;
          this.loadChartData(item, index);
        } else {
          // 有缓存时直接渲染
          this.$nextTick(() => {
            this.renderChart(item, index);
          });
        }
      } else {
        // 关闭时销毁图表实例
        if (item.chartInstance) {
          item.chartInstance.dispose();
          item.chartInstance = null;
        }
      }
    },
    // 加载图表数据
    async loadChartData(item, index) {
      try {
        const params = {
          groupType: this.parameter.groupType,
          productId:
            this.parameter.groupType == "1" ? item.productId : undefined,
          advertiserId:
            this.parameter.groupType == "0" ? item.advertiserId : undefined,
          dataType: this.actions.find(
            (a) => a.name === (item.sensitize || "激活")
          )?.value,
        };
        const res = await TrendChart(params);
        item.chartData = res; // 存储图表数据
      } catch (error) {
        console.error("加载图表数据出错:", error);
      } finally {
        item.isChartLoading = false; // 结束加载
        if (item.showChart) {
          this.$nextTick(() => {
            this.renderChart(item, index);
          });
        }
      }
    },
    // 渲染图表
    renderChart(item, index) {
      this.$nextTick(() => {
        const chartId = "chart-" + index;
        const chartDom = document.getElementById(chartId);
        if (!chartDom) return;

        // 销毁旧图表实例
        if (item.chartInstance) {
          item.chartInstance.dispose();
          item.chartInstance = null;
        }

        // 初始化新图表
        const chart = echarts.init(chartDom);
        item.chartInstance = chart;

        // item.chartData.startList = [150, 230, 224, 218, 135, 147, 260];
        // item.chartData.endList = [110, 230, 124, 118, 105, 47, 160];
        // item.chartData.dateList = [
        //   "Mon",
        //   "Tue",
        //   "Wed",
        //   "Thu",
        //   "Fri",
        //   "Sat",
        //   "Sun",
        // ];
        const todayTotal = this.calculateArrayTotal(
          item.chartData.startList || []
        );
        const yesterdayTotal = this.calculateArrayTotal(
          item.chartData.endList || []
        );

        console.log(todayTotal, yesterdayTotal);

        const option = {
          color: ["#25F292", "#2575F2"],
          tooltip: {
            trigger: "item",
          },
          legend: {
            data: ["今日", "昨日"],
            formatter: (name) => {
              if (name === "今日") return `${name} (${todayTotal})`;
              if (name === "昨日") return `${name} (${yesterdayTotal})`;
              return name;
            },
            icon: "rect",
            itemWidth: 10,
            itemHeight: 10,
            itemStyle: {
              borderWidth: 1,
            },
            textStyle: {
              padding: [0, 5, 0, 0],
            },
            top: "0%",
            height: 21,
            left: "20%",
            selectedMode: false,
          },
          grid: {
            top: 40,
            right: 10,
            bottom: 20,
          },
          xAxis: [
            {
              type: "category",
              axisTick: {
                alignWithLabel: true,
                inside: true,
                length: 3,
              },
              axisLine: {
                onZero: true,
              },
              data: item.chartData.dateList,
            },
          ],
          yAxis: [
            {
              type: "value",
            },
          ],
          series: [
            {
              name: "今日",
              type: "line",
              smooth: true,
              data: item.chartData.startList,
            },
            {
              name: "昨日",
              type: "line",
              smooth: true,
              data: item.chartData.endList,
            },
          ],
        };
        chart.setOption(option);

        // 窗口大小变化时的自适
        const resizeHandler = () => chart.resize();
        window.addEventListener("resize", resizeHandler);
        this.$once("hook:beforeDestroy", () => {
          window.removeEventListener("resize", resizeHandler);
        });
      });
    },
    // 重置所有图表状态
    resetCharts() {
      this.listData.forEach((item) => {
        if (item.showChart) {
          this.$set(item, "showChart", false);
        }
        if (item.chartInstance) {
          item.chartInstance.dispose();
          item.chartInstance = null;
        }
        item.chartData = null;
      });
    },

    async tabularData() {
      if (this.parameter.pageNo === 1) {
        this.listData = [];
        this.finished = false;
        this.resetCharts(); // 重置图表状态
      }
      if (this.finished) return; // 加载完不请求
      this.loading = true;
      try {
        const res = await AnalysisData(this.parameter);

        this.listData = this.listData.concat(
          res.list.map((item) => ({
            ...item,
            showChart: false,
            chartData: null,
            chartInstance: null,
            sensitize: "激活", // 添加默认值
            isChartLoading: false,
          }))
        );
        this.total = res.count;

        if (
          this.listData.length >= this.total ||
          res.list.length < this.parameter.pageSize
        ) {
          this.finished = true;
        }
      } catch (error) {
        console.error("获取列表出错:", error);
      } finally {
        this.loading = false;
        this.scrollLock = false;
      }
    },
    // 获取产品
    async loadProducts() {
      try {
        const params = {
          pageNo: 1,
          pageSize: 9999,
        };
        const res = await ProductData(params);
        this.allProducts = res.map((item) => ({
          label: item.productName,
          value: item.id,
        }));
      } catch (error) {
        console.error("获取产品列表出错:", error);
      }
    },
    async getGeneral() {
      try {
        const res = await OverviewData(this.parameter);
        this.aggregate = res;
      } catch (error) {
        console.error(error);
      }
    },
    // 日期选择
    handleDateChange(range) {
      this.parameter.startDate = range.startDate;
      this.parameter.endDate = range.endDate;
      this.parameter.pageNo = 1;
      this.tabularData();
      this.getGeneral();
    },

    // 产品选择处理
    async handleProductSelect(id) {
      this.parameter.productId = id;
      this.parameter.advertiserId = "";
      this.parameter.pageNo = 1; // 重置页码
      if (this.parameter.groupType == "0" && id) {
        try {
          const params = {
            productId: id,
            dataType: "1",
          };
          const res = await AccountData(params);
          this.allAdvert = res.list.map((item) => ({
            label: item.advertiserId,
            value: item.advertiserId,
          }));
        } catch (error) {
          console.error("获取账户列表出错:", error);
        }
      } else {
        this.allAdvert = [];
      }

      this.tabularData();
      this.getGeneral();
    },
    // 账户处理
    handleAdvertSelect(id) {
      this.parameter.advertiserId = id;
      this.parameter.pageNo = 1;
      this.tabularData();
      this.getGeneral();
    },

    onSelect(item) {
      this.showUs = false;
      this.sensitize = item.name;
      if (this.currentItem) {
        this.$set(this.currentItem, "sensitize", item.name);
        this.loadChartData(this.currentItem, this.currentIndex);
      }
    },
    // 切换tab
    SelectTab(data) {
      this.parameter.groupType = data.value;
      this.parameter.productId = "";
      this.parameter.advertiserId = "";

      this.parameter.pageNo = 1;
      this.tabularData();
      this.getGeneral();
    },
    // 滚动事件处理
    handleScroll() {
      if (this.scrollLock || this.loading || this.finished) return;
      const scrollEl = this.$refs.scrollContent;
      if (
        scrollEl.scrollHeight - scrollEl.scrollTop <=
        scrollEl.clientHeight + 50
      ) {
        this.scrollLock = true;
        this.parameter.pageNo += 1;
        this.tabularData();
        this.getGeneral();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.scroll-content {
  flex: 1;
  overflow-y: auto;
  margin-top: 106px; /* 顶部固定区域高度 */
  // margin-bottom: 70px; /* 底部TabBar高度 */
  padding: 12px 8px;
  padding-bottom: 70px; /* 底部TabBar高度 */

  box-sizing: border-box;
  .core {
    .cor_fat .co_ft_item {
      padding-top: 9px;
    }
    .cor_fat .co_ft_item span:nth-child(2) {
      margin-top: 6px;
    }
    p {
      font-family: PingFang SC;
      font-weight: 600;
      font-size: 14px;
    }
  }
  .grid {
    margin-top: 12px;
    .grid_tab {
      margin-bottom: 6px;
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 14px;
      span {
        color: #818181;
        margin-right: 23px;
        line-height: 20px;
      }
      .active {
        color: #2575f2;
        position: relative;
        text-align: center;
        u {
          position: absolute;
          bottom: -2px;
          width: 14px;
          left: 50%;
          margin-left: -10px;
          border: 1px solid #2575f2;
        }
      }
    }
    .ac {
      display: flex;
    }
    .fabric {
      width: 116px;
      height: 22px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #ded9d9;
      font-family: Inter;
      font-weight: 400;
      font-size: 10px;
      color: #000000;
      align-items: center;
      display: flex;
      .van-cell {
        padding: 0;
        padding-left: 10px;
        width: 100px;
        height: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      img {
        flex: 1;
        width: 12px;
        height: 13px;
        object-fit: contain;
      }
    }
  }
}
.cor_fat {
  width: 100%;
  height: 62px;
  background: #e3e4fe;
  border-radius: 6px;
  display: flex;
  justify-content: space-around;
  .co_ft_item {
    display: flex;
    flex-direction: column;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 10px;
    color: #313131;
    line-height: 20px;
    box-sizing: border-box;
    span:nth-child(2) {
      font-weight: 600;
      font-size: 12px;
      color: #000000;
      line-height: 20px;
    }
  }
}
.popupFrame {
  padding: 19px 16px;
  box-sizing: border-box;
  ::v-deep(.van-search) {
    padding: 0;
  }
  ::v-deep(.van-search),
  ::v-deep(.van-search__content) {
    border-radius: 16px !important;
    background: #f3f3f3;
  }

  .productList {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -5px;
    margin-top: 11px;
    .van-radio {
      flex: 0 0 calc(33.333% - 10px);
      margin: 0 5px 8px 5px;
      font-family: Inter;
      font-weight: 400;
      font-size: 12px;
      background: #eaeaea;
      border-radius: 4px;
      padding: 7px 0;
      text-align: center;
      box-sizing: border-box;
      ::v-deep(.van-radio__label) {
        color: #000000 !important;
      }
    }
    ::v-deep(.van-radio__icon .van-icon) {
      display: none !important;
    }
    ::v-deep(.van-radio__label) {
      margin: auto;
    }
    .actives {
      background: #2575f2;
      ::v-deep(.van-radio__label) {
        color: #ffffff !important;
      }
    }
  }
}
.tabulate {
  margin-top: 12px;
  .area {
    padding: 0 9px;
    box-sizing: border-box;
    margin-bottom: 10px;
    position: relative;
    border-radius: 4px;
    border: 1px solid #ededed;

    .crown {
      padding-top: 9px;
      font-family: Inter;
      font-weight: 600;
      font-size: 12px;
      color: #000000;
      line-height: 14px;
      .tick {
        font-weight: 400;
        font-size: 10px;
        color: #000000;
        line-height: 12px;
        margin-left: 24px;
      }
    }
    .area_fat {
      width: 100%;
      justify-content: space-between;
      background: none;
      height: 45px;
    }
    .trend {
      font-family: Inter;
      font-weight: 400;
      font-size: 10px;
      color: #2575f2;
      position: absolute;
      top: 6px;
      right: 7px;
      display: flex;
      align-items: center;
      img {
        width: 12px;
        height: 12px;
        margin-left: 5px;
      }
    }
    .figure {
      width: 100%;
      height: 165px;
      position: relative;
      .loading-indicator {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
      }
      .lfSide,
      .rtSide {
        position: absolute;
        z-index: 1;
        top: 3px;
      }
      .lfSide {
        left: 11px;
        font-family: Inter;
        font-weight: 400;
        font-size: 12px;
        color: #000000;
        line-height: 14px;
        img {
          width: 12px;
          height: 13px;
          margin-left: 10px;
        }
      }
      .rtSide {
        right: -3px;
        font-family: Inter;
        font-weight: 400;
        font-size: 12px;
        line-height: 14px;
      }
      .chart {
        height: 158px;
        width: 100%;
        margin-bottom: 8px;
      }
    }
  }
}
</style>
